/* eslint-disable react/jsx-no-bind */

import { jitsiLocalStorage } from '@jitsi/js-utils';
import { post } from 'axios';
import { sha256 } from 'js-sha256';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import styled from 'styled-components';

import { apiKEY } from '../../../base/config/constants';
import { Dialog, closeDialogs, isAnyDialogOpen } from '../../../base/dialog';
import { AnimatedSVG, Icon, IconVoiceCommand } from '../../../base/icons';
import { setVoiceCommandString } from '../../../base/mtApi/actions';
import { getLocalVideoTrack } from '../../../base/tracks';
import { recController } from '../../../local-recording';
import { checkText } from '../../constants';

const stringSimilarity = require('string-similarity');

// export const checkText: Object<String> = {
//     'DonorBox': 'Open donorbox',
//     'clicknPledge': 'Open click and pledge',
//     'Recording': 'Open recording',
//     'Livestream': 'Open livestream',
//     'WhiteBoard': 'Open whiteboard'
// };

const DIVs = styled.div`
padding: '10px'; 
`;

const Ps = styled.p`
font-size: 15px;
font-family: 'Poppins';
`;


export const VoiceCommandDialog = () => {
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();
    const { t } = useTranslation();
    const [ change, setChange ] = React.useState('');
    const [ listen, setListen ] = useState(false);
    const { accessToken } = useSelector(state => state['features/base/jwt']);
    const userAccessToken = jitsiLocalStorage.getItem('accessToken');
    const config = useSelector(state => state['features/base/config']);
    const accesTokn = accessToken ?? userAccessToken;
    const [ loader, setLoader ] = React.useState(false);
    const [ record, setRecorder ] = React.useState(false);
    const [ isNotSupported, setNotSupported ] = useState(true);
    const [ resData, setResData ] = useState('');
    const dispatch = useDispatch();
    const localVideo = useSelector(state => getLocalVideoTrack(state['features/base/tracks']));
    const store = useSelector(state => state);
    const isMounted = React.useRef(false);

    // const ClickEvent = event => {
    //     event.preventDefault();
    //     if (!listening) {
    //         SpeechRecognition.startListening();

    //         return;
    //     }

    //     SpeechRecognition.stopListening();

    // };
    React.useMemo(() => {
        if (localVideo && localVideo.videoType === 'desktop' && isMounted.current === true) {
            // eslint-disable-next-line no-use-before-define
            if (isAnyDialogOpen(store)) {
                // eslint-disable-next-line no-use-before-define
                dispatch(closeDialogs(true));
            }
        }
    }, [ localVideo ]);

    useEffect(
        () => {
            if (!browserSupportsSpeechRecognition && isNotSupported) {
                setNotSupported(!isNotSupported);
            }
            isMounted.current = true;

            return () => {
                if (listening && !isNotSupported) {
                    SpeechRecognition.stopListening();
                }

                if (listen && isNotSupported) {
                    // eslint-disable-next-line no-use-before-define
                    recController.stopRecording(disptch);
                }
            };
        },
        [ ]
    );

    React.useMemo(() => {
        if (!listening && transcript) {
            setListen(false);
            setLoader(true);
            setTimeout(() => {
                const matches = stringSimilarity.findBestMatch(transcript, Object.values(checkText));

                if (matches.bestMatch.rating >= 0.5) {
                    setLoader(false);

                    const key = Object.keys(checkText)[matches?.bestMatchIndex];

                    // console.log('matches', matches?.bestMatchIndex, matches, key, transcript);
                    dispatch(setVoiceCommandString(key));
                    resetTranscript();
                } else {
                    resetTranscript();
                    setResData('The Command does not match what you are looking for');
                    setLoader(false);
                }

            }, 5000);


        }
        if (!listening && !_.isEmpty(change)) {
            const matches = stringSimilarity.findBestMatch(change, Object.values(checkText));

            // console.log('matches', matches?.bestMatchIndex, matches);
            if (matches.bestMatch.rating >= 0.5) {
                const key = Object.keys(checkText)[matches?.bestMatchIndex];

                dispatch(setVoiceCommandString(key));
            }


            setListen(false);
        }
    }, [ change, listening, transcript ]);

    const disptch = async key => {
        setLoader(true);
        const file = new File([ key ], 'microphone.flac',
            {
                type: 'flac',
                lastModified: new Date().getTime()
            }
        );

        const moement = moment().seconds(0)
        .milliseconds(0)
        .format('X');

        const mesh256 = sha256(`${apiKEY}:MH:${moement}`);

        const formData = new FormData();

        formData.append('audioFile', file);
        formData.append('client_id', config.MH_CLIENT_ID);
        formData.append('credentials', mesh256);

        const apiconfig = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': `Bearer ${accesTokn}`
            }
        };
        const path = 'speechtotext';
        const urlConfig = `${config.API_URL_PREFIX}${config.API_VERSION_PREFIX}${path}`;

        const response = await post(urlConfig, formData, apiconfig);

        setResData(response.data.transcript);

        const matches = stringSimilarity.findBestMatch(response.data.transcript, Object.values(checkText));


        // console.log('matches', matches?.bestMatchIndex, matches);
        setTimeout(() => {
            if (matches.bestMatch.rating >= 0.5) {
                const keys = Object.keys(checkText)[matches?.bestMatchIndex];

                dispatch(setVoiceCommandString(keys));

            }
            setLoader(false);
            setRecorder(false);
        }, 10000);

        // downloadBlob(key, 'DispatchRec');
        // console.log('disptch', file, response.data);

        // dispatch(setVoiceCommandString(key));
    };

    const onListenClick = async e => {
        e.preventDefault();
        // eslint-disable-next-line no-negated-condition
        if (!isNotSupported) {
            setListen(true);
            setResData('');
            setRecorder(true);
            recController.startRecording();

            setTimeout(async () => {
                setListen(false);
                recController.stopRecording(disptch);

            }, 10000);

            return;
        }

        // eslint-disable-next-line no-negated-condition
        if (!listening) {
            setListen(true);
            resetTranscript();
            SpeechRecognition.startListening();

        }

        setTimeout(() => {
            SpeechRecognition.stopListening();
            setListen(false);
            setChange(transcript);
        }, 10000);


        return;


    };


    // const response = await axios.get('http://localhost:3002/api/speech-to-text/')
    // .catch(es => console.log('onCick', es));


    return (<Dialog
        disableFooter = { true }
        titleKey = { t('voicecommand.vcLabel') }
        width = 'medium'>
        <DIVs
            className = 'voice-app'>
            <div className = 'help-tip'>
                <p> {t('voicecommand.hints.hints', { lng: 'en' })}: <br />
                    1.{t('voicecommand.hints.openDonorbox', { lng: 'en' })}<br />
                    2.{t('voicecommand.hints.removeDonorbox', { lng: 'en' })}<br />
                    3.{t('voicecommand.hints.openClickAndPledge', { lng: 'en' })}<br />
                    4.{t('voicecommand.hints.removeClickAndPledge', { lng: 'en' })}<br />
                    5.{t('voicecommand.hints.openRecording', { lng: 'en' })}<br />
                    6.{t('voicecommand.hints.openLivestream', { lng: 'en' })}<br />
                    7.{t('voicecommand.hints.openWhiteboard', { lng: 'en' })}<br />
                    8.{t('voicecommand.hints.openLivePad', { lng: 'en' })}<br />
                    9.{t('voicecommand.hints.closeLivePad', { lng: 'en' })}<br />
                    10.{t('voicecommand.hints.closeWhiteboard', { lng: 'en' })}<br />
                    11.{t('voicecommand.hints.startScreenSharing', { lng: 'en' })}<br />
                    12.{t('voicecommand.hints.StopScreenSharing', { lng: 'en' })}<br />
                    13.{t('voicecommand.hints.openYoutube', { lng: 'en' })}<br />
                    14.{t('voicecommand.hints.closeYoutube', { lng: 'en' })}<br />
                    15.{t('voicecommand.hints.openParticipantPane', { lng: 'en' })}<br />
                    16.{t('voicecommand.hints.openVirtualBackground', { lng: 'en' })}<br />
                    17.{t('voicecommand.hints.openChatBox', { lng: 'en' })}<br />
                    18.{t('voicecommand.hints.openVideoQualityDialog', { lng: 'en' })}<br />
                    19.{t('voicecommand.hints.openSpeakerStats', { lng: 'en' })}<br />
                    20.{t('voicecommand.hints.openSettings', { lng: 'en' })}<br />
                    21.{t('voicecommand.hints.openFullScreen', { lng: 'en' })}<br />
                    22.{t('voicecommand.hints.invitePeople', { lng: 'en' })}<br />
                    23.{t('voicecommand.hints.raiseHand', { lng: 'en' })}<br />
                    24.{t('voicecommand.hints.lowerHand', { lng: 'en' })}</p>
            </div>
            <h2>{t('voicecommand.voiceCommandForMeethour')}</h2>
            <h3>{t('voicecommand.clickOnMic')}</h3>
            <button
                className = 'btn-mic mb-4 mt-4'
                id = 'speech'

                onClick = { onListenClick }>
                {listen || listening ? <div className = 'pulse-ring' /> : '' }
                <Icon
                    alt = 'microphone'
                    size = { 50 }
                    src = { loader ? AnimatedSVG : IconVoiceCommand } />
            </button>
            {!isNotSupported && record && _.isEmpty(resData) ? <h4>{t('voicecommand.pleaseWaitWeAreRecording')}</h4> : null}
            <Ps>{transcript || resData}</Ps>
            <ul id = 'playlist' />
        </DIVs>
    </Dialog>);

};

